import React, { Component } from 'react';
import { withAuthorization } from '../session';
import Loader from 'react-loader-spinner';
import ModalInfo from '../useful/ModalInfo';

const INITIAL_STATE = {
    loading: false,
    passwordOne: '',
    passwordTwo: '',
    modal: {
        show: false,
        title: '',
        message: ''
    }
};

// Modal.setAppElement('#root');
class PasswordChange extends Component {

    constructor(props) {
        super(props);
        this.state = { ...INITIAL_STATE };
    }

    handleSubmit = event => {
        event.preventDefault();

        const { passwordOne, passwordTwo } = this.state;
        const isInvalid = passwordOne !== passwordTwo || passwordOne === '';

        if (!isInvalid) {
            this.setState({ loading: true });

            this.props.firebase
                .doPasswordChange(passwordOne)
                .then(() => {
                    this.setState({ ...INITIAL_STATE });
                    this.showModal("Información", "Su contraseña fue cambiada con éxito.");
                })
                .catch(error => {
                    this.setState({ loading: false });
                    if (error && error.code && error.code == "auth/requires-recent-login")
                        this.showModal("Error", "Su sessión ha expirado. Debe salir y volver a iniciar sessión para poder cambiar su contraseña.");
                    else
                        this.showModal("Error", "Lo sentimos, no se pudo cambiar la contraseña. La contraseña debe tener al menos 6 caracteres.");
                    console.log("Error: ", error);
                });
        } else {
            this.showModal("Error", "Los datos introducidos son incorrectos.");
        }

    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    showModal = (title, message) => {
        this.setState({
            modal: {
                show: true,
                title: title,
                message: message
            }
        });
    }

    closeModal = () => {
        this.setState({
            modal: {
                show: false,
                title: '',
                message: ''
            }
        });
    }

    render() {
        const { loading, passwordOne, passwordTwo, modal } = this.state;
        const isInvalid =
            passwordOne !== passwordTwo || passwordOne === '';

        return (
            <div>

                <form className="form-signin text-center" onSubmit={this.handleSubmit}>
                    <h1 className="h3 mb-3 font-weight-normal">Cambiar Contraseña</h1>

                    <div className="form-group text-left">
                        <label className="small text-secondary mb-0 ml-1" htmlFor="passwordOne">Nueva contraseña:</label>
                        <input value={passwordOne} onChange={this.handleChange} className="form-control"
                            type="password" id="passwordOne" name="passwordOne"
                            placeholder="......" required="" />
                    </div>

                    <div className="form-group text-left">
                        <label className="small text-secondary mb-0 ml-1" htmlFor="passwordTwo">Repetir contraseña:</label>
                        <input value={passwordTwo} onChange={this.handleChange} className="form-control"
                            type="password" id="passwordTwo" name="passwordTwo"
                            placeholder="......" required="" />
                    </div>


                    {/* <input value={passwordOne} onChange={this.handleChange} name="passwordOne" type="password" className="form-control" placeholder="Nueva contraseña" required="" /> */}

                    {/* <input value={passwordTwo} onChange={this.handleChange} name="passwordTwo" type="password" className="form-control mt-3" placeholder="Repetir nueva contraseña" required="" /> */}

                    {(!loading) ?
                        <button disabled={isInvalid} className="mt-3 btn btn btn-app btn-block" type="submit">Cambiar</button>
                        :
                        <div className="nav justify-content-center row">
                            <Loader className="mt-4"
                                type="ThreeDots"
                                color="#263238"
                                height={60}
                                width={60}
                                timeout={0} />
                        </div>
                    }

                </form>

                <ModalInfo
                    data={modal}
                    onClose={this.closeModal}
                />

            </div>

        );
    }
}

const condition = authUser => !!authUser;
export default withAuthorization(condition)(PasswordChange);